import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Graduation-Cap--Streamline-Flex"
    >
        <desc>
            {'Graduation Cap Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="graduation-cap--graduation-cap-education">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.63393 12.5011c0.55594 0 1.00661 -0.4507 1.00661 -1.0066s-0.45067 -1.0066 -1.00661 -1.0066 -1.006611 0.4507 -1.006611 1.0066 0.450671 1.0066 1.006611 1.0066Z"
                strokeWidth={1}
            />
            <path
                id="Ellipse 347"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m1.63391 10.4879 0 -4.76915"
                strokeWidth={1}
            />
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.4627 6.70099c0.0096 0.19251 0.0152 0.38636 0.0152 0.5814 0 0.4865 -0.0344 0.96554 -0.0807 1.43514 -0.0972 0.98718 -0.8953 1.78487 -1.87555 1.88357 -0.4975 0.0501 -1.00546 0.0885 -1.52162 0.0885s-1.02411 -0.0384 -1.52161 -0.0885c-0.98025 -0.0987 -1.77835 -0.89639 -1.87559 -1.88358 -0.04625 -0.46959 -0.08061 -0.94863 -0.08061 -1.43513 0 -0.19504 0.00552 -0.38889 0.01512 -0.5814"
                strokeWidth={1}
            />
            <path
                id="Intersect_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.888905 4.13763c-0.518355 0.31891 -0.518049 0.77609 -0.002026 1.09591 0.714381 0.44276 1.452951 0.90254 2.311151 1.32394 0.8582 0.4214 1.79456 0.78406 2.69624 1.13485 0.65132 0.25338 1.58239 0.25353 2.23185 -0.001 0.89478 -0.35067 1.82152 -0.71436 2.67588 -1.13385 0.8543 -0.4195 1.5949 -0.87455 2.3091 -1.31392 0.5183 -0.3189 0.518 -0.77609 0.002 -1.0959 -0.7144 -0.44276 -1.4529 -0.90254 -2.3111 -1.32394 -0.85825 -0.4214 -1.7946 -0.78406 -2.69629 -1.13485 -0.65132 -0.25338 -1.58238 -0.25353 -2.23185 0.001 -0.89477 0.35066 -1.82151 0.71435 -2.67583 1.13385 -0.85432 0.41949 -1.59498 0.87455 -2.309125 1.31391Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
